import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-macro-summary',
  templateUrl: './macro-summary.component.html',
  styleUrls: ['./macro-summary.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MacroSummaryComponent implements OnInit {

  @Input('summmary') public data: any;

  constructor() { }

  ngOnInit(): void {
  }

}
